import { render, staticRenderFns } from "./PoTovarov.vue?vue&type=template&id=17abf32c&scoped=true&"
import script from "./PoTovarov.vue?vue&type=script&lang=js&"
export * from "./PoTovarov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17abf32c",
  null
  
)

export default component.exports